module.controller('esignDisclosureCtrl', [
    '$scope', '$state', '$sce', '$stateParams', 'brandService', '$window', '$http',
    function ($scope, $state, $sce, $stateParams, brandService, $window, $http) {
        var vm = this;

        $window.scrollTo(0, 0);

        vm.section1 = true;
        vm.section2 = false;
        vm.section3 = false;
        vm.section4 = false;

        vm.eSignAgreed = false;
        vm.disclosureAgreed = false;
        vm.privacyAgreed = false;
        vm.feesScheduleAgreed = false;

        $scope.eSignErrorMessage = 'Please check this box if you agree to the E-sign disclosure. You must agree to the E-sign disclosure to continue.';
        $scope.cardholderAgreementErrorMessage = 'Please check this box if you agree to the Cardholder Agreement. You must agree to the Cardholder Agreement to continue.';
        $scope.privacyPolicyErrorMessage = 'Please check this box if you agree to the Sunrise Banks Privacy Policy. You must agree to the Sunrise Banks Privacy Policy to continue.';

        var urlRoot = window.location.href.split('#')[0];
        var currentBrand = $scope.brand.name;
        var brand = brandService.getBrand($stateParams.brand);

        function resolvePdfUrl(basePath, fallbackPath, callback) {
            $http.head(basePath).then(
                function () {
                    callback(basePath);
                },
                function () {
                    callback(fallbackPath);
                }
            );
        }

        function initializePdfSources() {
            var defaultAgreement = 'https://akimbocard.wpenginepowered.com/wp-content/uploads/2021/07/Cardholder-Agreement_GPR_Akimbo_FICENTIVEAKIMBOMCGPRTC_0721-8.pdf';
            var currentBrandAgreement = urlRoot.replace('?', '') + 'assets/pdf/' + currentBrand + '/cardholder-agreement.pdf';

            resolvePdfUrl(
                currentBrandAgreement,
                defaultAgreement,
                function (resolvedUrl) {
                    vm.pdfGDSrcAgreement = resolvedUrl + '#toolbar=0';
                    vm.pdfGDSrcAgreementDownload = resolvedUrl;
                }
            );

            var defaultFeeSchedule = urlRoot.replace('?', '') + 'assets/pdf/akimbo/fee-schedule.pdf';
            var currentBrandFeeSchedule = urlRoot.replace('?', '') + 'assets/pdf/' + currentBrand + '/fee-schedule.pdf';

            resolvePdfUrl(
                currentBrandFeeSchedule,
                defaultFeeSchedule,
                function (resolvedUrl) {
                    vm.feesSchedule = resolvedUrl + '#toolbar=0';
                    vm.feesScheduleDownload = resolvedUrl;
                }
            );

            vm.pdfGDSrcDisclosure = brand.programLegal.disclosure + '#toolbar=0';
            vm.pdfGDSrcDisclosureDownload = brand.programLegal.disclosure;

            vm.pdfGDSrcPrivacy = 'https://akimbocard.wpenginepowered.com/wp-content/uploads/2020/03/Sunrise-Banks-Privacy-Notice-Safe-Harbor.pdf#toolbar=0';
            vm.pdfGDSrcPrivacyDownload = 'https://akimbocard.wpenginepowered.com/wp-content/uploads/2020/03/Sunrise-Banks-Privacy-Notice-Safe-Harbor.pdf';

            vm.feesSchedule = urlRoot.replace('?', '') + 'assets/pdf/' + currentBrand + '/fee-schedule.pdf#toolbar=0';
            vm.feesScheduleDownload = urlRoot.replace('?', '') + 'assets/pdf/' + currentBrand + '/fee-schedule.pdf';
        }

        vm.trustSrc = function (src) {
            return $sce.trustAsResourceUrl(src);
        };

        vm.Finish = function (nextStep) {
            $state.go(nextStep, { joinType: $scope.joinType });
        };

        vm.downloadFile = function (url, filename) {
            var link = $window.document.createElement('a');
            link.href = url;
            link.download = filename;
            link.target = '_blank';
            $window.document.body.appendChild(link);
            link.click();
            $window.document.body.removeChild(link);
        };

        function initializeController() {
            initializePdfSources();
        }

        initializeController();
    }
]);
